/* eslint-disable max-len */
/* eslint-disable react/no-danger */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/sort-comp */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import SignatureCanvas from 'react-signature-canvas';
import { FormattedMessage } from 'react-intl';
import PulpoField from '../../pulpo_visualizer/fields/PulpoField';
import Collapsible from '../collapsible/Collapsible';
import { fetchDataSourceList } from '../../modules/inspections/redux/actions';
import styles from './customField.module.scss';
import Button from '../button/button';
import FormattedMessageWithClass from '../formattedMessageWithClass';
import Attachments from '../../modules/forms/components/Attachments';
import MultiColumnGrid from '../../modules/forms/MultiColumnGrid';
import TooltipWithHeading from '../../helpToolTip/ToolTip';
import Annotations from '../Annotations/Annotation';
import { checkFilesValidation, getFieldUsesSeconds, imageFileExtensions, docFileExtensions, EMPTY_ARRAY } from '../../utils/helpers';
import MultiLevelLocation from '../../pulpo_visualizer/fields/multi-level-location';
import { getFieldCalculation } from '../../modules/forms/utils/helpers';
import { runCumulativeCalculation } from './runcumulativecalculation';

class CustomFields extends Component {
  constructor(props) {
    super(props);
    this.sigCanvas = {};
    this.state = {
      previewUrl: {},
      hasDrawnSignature: {}
    };
  }

  componentDidMount() {
    const { actionFetchDataSources, allDataSources } = this.props;
    if (!allDataSources?.length) {
      actionFetchDataSources();
    }
    this.handleResize();
    window.addEventListener('resize', this.handleResize);
  }

  componentDidUpdate(prevProps) {
    const { answers, formEntryFields, handleAnswerChanged } = this.props;
    if (prevProps.answers !== answers || prevProps.formEntryFields !== formEntryFields) {
    runCumulativeCalculation({
      answers,
      fields: formEntryFields,
      prevAnswers: prevProps.answers,
      prevFields: prevProps.fields,
      handleAnswerChanged,
      getFieldCalculation // assume this is in scope or passed as a prop
    });
    }
  }

  componentWillUnmount() {
  window.removeEventListener('resize', this.handleResize);
}


  checkConditionalValue = (field) => {
    const { answers, form_entry_data, useCurrentStep, formApprovalProcess, processStep, applicationType } = this.props;
    const conditionalKey = field?.conditional_field?.key;
    const conditionalStep = field?.conditional_step;
    let isValue = false;
    let haveAnswers = answers || {};
    if (conditionalStep === 'form_entry') {
      haveAnswers = form_entry_data;
    }
    if (formApprovalProcess?.length && conditionalStep !== 'form_entry') {
      let stepsAnswers = formApprovalProcess.find(useStep => useStep.step_id === conditionalStep)?.data || {};
      haveAnswers = { ...stepsAnswers };
    }
    let useCurrentStepFilter = processStep?.current_step;
    if (processStep?.current_step?.split(',')?.length > 1) {
      useCurrentStepFilter = useCurrentStep?.id;
    }
    if (useCurrentStepFilter === conditionalStep) {
      haveAnswers = { ...answers };
    }
    if (conditionalKey === 'application_type' && applicationType === 'New') {
      isValue = field?.conditional_values?.some(item => item.value === 'New');
    } else if (conditionalKey === 'application_type' && applicationType === 'Renewal') {
      isValue = field?.conditional_values?.some(item => item.value === 'Renew');
    } else if (typeof haveAnswers[conditionalKey] === 'string') {
      isValue = field?.conditional_values.filter(
        value => haveAnswers[conditionalKey] === value.value
      ).length > 0;
    } else if (typeof haveAnswers[conditionalKey] === 'object') {
      if (Array.isArray(haveAnswers[conditionalKey])) {
        isValue = field?.conditional_values.some(
            value => haveAnswers[conditionalKey]?.indexOf(value.value) !== -1
        );
    } else if (haveAnswers[conditionalKey]?.level_1) {
      isValue = Object.values(haveAnswers[conditionalKey])
      ?.filter(value => value !== '')?.join() === Object.values(field.conditional_values[0])?.filter(value => value !== '')?.join();
    }
    } else if (typeof haveAnswers[conditionalKey] === 'boolean') {
      isValue = field?.conditional_values.filter(
        value => (
          haveAnswers[conditionalKey].toString() === value?.value
        )
      ).length > 0;
    }
    return isValue;
  }

  // CHECK THE FIELD VALUE IS PRESENT OR NOT
  checkValueInFormEntry = (fieldInfo) => {
    const { answers, form_entry_data, formApprovalProcess, applicationType } = this.props;
    let isVal = false;
    const conditionalKey = fieldInfo?.conditional_field?.key;
    const conditionalStep = fieldInfo?.conditional_step;
    if (form_entry_data && conditionalStep === 'form_entry') {
      isVal = form_entry_data[conditionalKey] !== '';
    }
    if (conditionalStep !== 'form_entry') {
      isVal = answers[conditionalKey] !== '';
    }
    if (formApprovalProcess?.length && conditionalStep !== 'form_entry') {
      let stepsAnswers = formApprovalProcess.find(useStep => useStep.id === conditionalStep)?.data || {};
      isVal = stepsAnswers[conditionalKey] !== '';
    }
    if (conditionalKey === 'application_type' && applicationType === 'New') {
     isVal = fieldInfo?.conditional_values?.some(item => item.value === 'New');
    }
    if (conditionalKey === 'application_type' && applicationType === 'Renewal') {
      isVal = fieldInfo?.conditional_values?.some(item => item.value === 'Renew');
    }
    return isVal;
  }

  handleSign = (fieldId) => {
    const { handleAnswerChanged, handleFieldErrorChanged } = this.props;
    const canvas = this.sigCanvas[fieldId];

    if (!canvas || canvas.isEmpty()) return;

    const dataUrl = canvas
      .getTrimmedCanvas()
      .toDataURL('image/png');

    const file = this.dataURLtoFile(dataUrl, `${fieldId}.png`);

    this.setState(prev => ({
      hasDrawnSignature: {
        ...prev.hasDrawnSignature,
        [fieldId]: true
      }
    }));

    handleAnswerChanged(file, fieldId);
    handleFieldErrorChanged(fieldId, false);
  };

  signClear = (fieldId, isRequired) => {
  const { handleAnswerChanged, handleFieldErrorChanged } = this.props;

    if (!this.sigCanvas[fieldId]) return;

    this.sigCanvas[fieldId].clear();

    this.setState((prev) => {
      const previews = { ...prev.previewUrl };
      const drawn = { ...prev.hasDrawnSignature };
      delete previews[fieldId];
      delete drawn[fieldId];

      return {
        previewUrl: previews,
        hasDrawnSignature: drawn
      };
    });

    handleAnswerChanged([], fieldId);
    handleFieldErrorChanged(fieldId, !!isRequired);
    const driver_signature = document.getElementById(`driver_signature_upload_file_input_${fieldId}`);
    if (driver_signature) {
      driver_signature.value = [];
    }
  };

  handleResize = () => {
    Object.keys(this.sigCanvas).forEach(this.resizeCanvas);
  };

  handleSignData = (fieldId, data) => {
    const { signData } = this.state;
    this.setState({ signData: { ...signData, [fieldId]: data } });
  }

 resizeCanvas = (fieldId) => {
  const sig = this.sigCanvas[fieldId];
  if (!sig) return;

  const data = sig.isEmpty() ? null : sig.toData();

  const canvas = sig.getCanvas();
  const ctx = canvas?.getContext('2d');
  const ratio = Math.max(window.devicePixelRatio || 1, 1);
  const rect = canvas?.getBoundingClientRect();

  canvas.width = rect.width * ratio;
  canvas.height = rect.height * ratio;

  ctx.setTransform(ratio, 0, 0, ratio, 0, 0);

  if (data) {
    sig.fromData(data);
  }
  };


  getAddress = (addressValue) => {
    const address1 = [addressValue?.street, addressValue?.fulladdress, addressValue?.zip, addressValue?.country?.label];
    let updatedAddress = [];
    if (address1) {
      address1.map((e) => {
        if (e && e !== '') {
          updatedAddress = [
            ...updatedAddress,
            e
          ];
        }
        return null;
      });
    }
    return updatedAddress?.join(', ');
  }

  dataURLtoFile = (dataurl, filename) => {
    let arr = dataurl.split(',');


let mime = arr[0].match(/:(.*?);/)[1];


let bstr = atob(arr[1]);


let n = bstr.length;


let u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
  }

  // OVERRIDE FIELD TYPE IF NEED
  handleGetFieldType = (typeInfo) => {
    let fieldHasType = typeInfo.type;
    if (typeInfo?.type === 'string' && typeInfo?.validators?.length > 0 && typeInfo?.validators?.[0]?.label === 'Phone Number') {
      fieldHasType = 'telephone';
    } else if (['dateWithSeconds', 'datetimeWithSeconds', 'only_time_with_seconds'].includes(typeInfo?.type)) {
      fieldHasType = typeInfo?.type?.includes('time') ? 'time' : 'datetime';
    } else if (typeInfo?.type === 'date' && (typeInfo?.settings?.dateWithSeconds || typeInfo?.dateWithSeconds)) {
      fieldHasType = 'datetime';
    } else if (typeInfo?.type === 'number' && typeInfo?.validators?.length > 0 && typeInfo?.validators?.[0]?.type === 'currencyInput') {
      fieldHasType = 'currency-phone';
    }
    return fieldHasType;
  }

  // SET OTHER PROPS TO PULPOFILED IF NEED
  getOtherFieldInfo = (typeInfo) => {
    const { user } = this.props;
    let otherFieldInfo = {};
    if (typeInfo?.type === 'number' && typeInfo?.validators?.length > 0 && typeInfo?.validators?.[0]?.type === 'currencyInput') {
      otherFieldInfo = {
        prefix: user?.portal_airport?.airport_settings?.currency || '$',
        thousandSeparator: true,
        placeHolderValue: user?.portal_airport?.airport_settings?.currency || '$',
        decimalDigits: 2
      };
    }
    otherFieldInfo = {
      ...otherFieldInfo,
      sendWithSecond: getFieldUsesSeconds(typeInfo)
    };
    return otherFieldInfo;
  }

  handleGetPortalUsersValues = (portalUserField) => {
    const { portal_users_list, accessibleTenants, user } = this.props;

    let portalUsersDropdownValues = portal_users_list?.filter(portalUser => portalUser.id !== user?.id) || [];

    if (accessibleTenants?.length > 0) {
      portalUsersDropdownValues = portal_users_list?.filter(ptUser => ptUser?.tenant
            ?.filter(eachTenant => user?.current_tenant?.id === eachTenant?.id && accessibleTenants?.includes(eachTenant.id))?.length > 0);
    }
    // FILTER USERS BY SELECTED JOB FUNCTIONS
    // IF NO JOB FUNCTIONS RETURN ALL USERS
    if (portalUserField?.settings?.portalUserSelectedJobFunctions?.length) {
      portalUsersDropdownValues = portalUsersDropdownValues
      .filter(jobFunUser => portalUserField?.settings?.portalUserSelectedJobFunctions?.some(jobFun => jobFunUser.assignment?.some(assign => assign.id === jobFun.value)));
    }

    if (portalUserField?.settings?.show_tenant_specific_users_in_portal_user_field) {
      // THIS CONDITION IS ABOUT CURRENT TENANT USERS WILL SHOW ON THE DROPDOWN
      portalUsersDropdownValues = portalUsersDropdownValues?.filter(tenantUser => tenantUser?.tenant
      ?.some(tntUser => tntUser?.id === user?.current_tenant?.id));
    }

    portalUsersDropdownValues = portalUsersDropdownValues?.map(eachVal => ({
        value: eachVal.fullname,
        key: eachVal.id,
        tenantName: eachVal.tenant?.map((Tname) => {
          if (accessibleTenants?.length) {
            return accessibleTenants.some(tenant => tenant === Tname.id) ? Tname.name : undefined;
          }
          return Tname.name;
        }).filter(Boolean)
     }));

    return portalUsersDropdownValues;
  }


  handleFileChange = (event, fieldId) => {
    const { handleAnswerChanged, handleFieldErrorChanged } = this.props;
    const file = event.target.files[0];

    if (!file || !fieldId) return;

    const reader = new FileReader();
    reader.onloadend = () => {
      this.setState(prev => ({
        previewUrl: {
          ...prev.previewUrl,
          [fieldId]: reader.result
        }
      }));
    };

    reader.readAsDataURL(file);
    handleAnswerChanged(file, fieldId);
    handleFieldErrorChanged(fieldId, false);
  };

  handleMultiLocation = (corr, type, shape, fieldId, allowMultiple = false) => {
    const { handleAnswerChanged, answers, handleFieldErrorChanged } = this.props;
    let longlat = answers[fieldId] || {};
    if (allowMultiple) {
      longlat[type] = corr;
    } else if (shape === 'Point') {
      longlat[type] = { type: 'Point', coordinates: corr };
    } else if (shape === 'Polygon') {
      longlat[type] = { type: 'Polygon', coordinates: [corr] };
    } else if (shape === 'Polyline') {
      longlat[type] = { type: 'LineString', coordinates: corr };
    }
    handleAnswerChanged(longlat, fieldId);
    handleFieldErrorChanged(fieldId, false);
  }

  handleRemoveChanged = (corr, type, shape, fieldId, allowMultiple = false) => {
    const { handleAnswerChanged, answers, handleFieldErrorChanged } = this.props;
    if (allowMultiple) {
      const formatCoord = ([lng, lat]) => `${lng},${lat}`;
      let longlat = answers[fieldId] || {};
      if (shape === 'Point') {
        longlat = {
          ...longlat,
          locations: longlat?.locations?.filter(loc => loc.coordinates[0] !== corr[0] && loc.coordinates[1] !== corr[1])
        };
      } else if (shape === 'Polygon') {
        let valueSet = new Set(corr.map(formatCoord));
        longlat = {
          ...longlat,
          polygons: longlat?.polygons?.filter(polygon => polygon.coordinates[0].every(coords => !valueSet.has(formatCoord(coords))))
        };
      } else if (shape === 'Polyline') {
        let valueSet = new Set(corr.map(formatCoord));
        longlat = {
          ...longlat,
          polylines: longlat?.polylines?.filter(polyline => polyline.coordinates.every(coords => !valueSet.has(formatCoord(coords))))
        };
      }
      const checkData = Object.values(longlat).every(
        value => value === undefined || (Array.isArray(value) && value.length === 0)
      );
      if (checkData) {
        handleFieldErrorChanged(fieldId, true);
        handleAnswerChanged('', fieldId);
      } else {
        handleFieldErrorChanged(fieldId, false);
        handleAnswerChanged(longlat, fieldId);
      }
    } else {
      let longlat = answers[fieldId] || {};
      delete longlat[type];

      if (Object.keys(longlat)?.length === 0) {
        handleFieldErrorChanged(fieldId, true);
        handleAnswerChanged('', fieldId);
      } else {
        handleFieldErrorChanged(fieldId, false);
        handleAnswerChanged(longlat, fieldId);
      }
    }
  };

  handleEditChanged = (corr, prevcorr, type, shape, fieldId, allowMultiple = false) => {
    const { handleAnswerChanged, answers, handleFieldErrorChanged } = this.props;
    if (allowMultiple) {
      let longlat = answers[fieldId] || {};
      let existingShape = longlat[type] || [];

      if (shape === 'Point') {
        let indexToUpdate = existingShape.findIndex(obj => obj.coordinates[0] === prevcorr[0] && obj.coordinates[1] === prevcorr[1]);
        if (indexToUpdate !== -1) {
          existingShape[indexToUpdate].coordinates = corr;
        }
      } else if (shape === 'Polygon') {
        existingShape = prevcorr.map((c) => {
          if (c?.coordinates?.length > 0) {
            let cor = c?.coordinates;
            const first = cor[0];
            const last = cor[cor.length - 1];
            if (first[0] !== last[0] || first[1] !== last[1]) {
              cor.push([...first]);
            }
            return {
              type: 'Polygon',
              coordinates: [cor]
            };
          }
          return null;
        });
      } else if (shape === 'Polyline') {
        existingShape = prevcorr.map(c => ({ type: 'LineString', coordinates: c.coordinates }));
      }

      longlat[type] = existingShape;
      handleAnswerChanged(longlat, fieldId);
      handleFieldErrorChanged(fieldId, false);
    } else {
      let longlat = answers[fieldId] || {};
      if (shape === 'Point') {
        longlat[type] = { type: 'Point', coordinates: corr };
      } else if (shape === 'Polygon') {
        if (prevcorr[0]?.coordinates?.length > 0) {
          let cor = prevcorr[0]?.coordinates;
          const first = cor[0];
          const last = cor[cor.length - 1];
          if (first[0] !== last[0] || first[1] !== last[1]) {
            cor.push([...first]);
          }
          longlat[type] = {
            type: 'Polygon',
            coordinates: [cor]
          };
        }
      } else if (shape === 'Polyline') {
        longlat[type] = {
          type: 'LineString',
          coordinates: prevcorr[0]?.coordinates
        };
      }
      handleAnswerChanged(longlat, fieldId);
      handleFieldErrorChanged(fieldId, false);
    }
  }

  getShowFieldErrors = (field, renewal, requiredMap, fromForms, fieldErrors, showFormErrors, errorsList, adprenewal, errors) => {
    if (!renewal) {
      if (requiredMap[field.id]) {
        // for mandatory field errors
        return (
          ((fromForms && fieldErrors)
            ?((fieldErrors?.[field?.id] && showFormErrors) || (errorsList && errorsList[field.id]))
             : (showFormErrors || (errorsList && errorsList[field.id])))
        );
      }
        // for optional errorlist
        if ((errorsList && errorsList[field.id])) {
          return true;
        }
        return false;
    }
      if (adprenewal) {
        return errors[field.id];
      }
      return false;
  }

  render() {
    const {
      fields,
      formTabFeilds,
      allDataSources,
      handleAnswerChanged,
      handleFieldErrorChanged,
      edit,
      handleRemove,
      fieldPropStyles,
      renewal,
      ageCheck,
      myforms,
      myformApprovals,
      user,
      profilePic,
      handleUploadAttachments,
      globalLocationList,
      placeHolders,
      handleAttachmentFailedAlert,
      handleAutoUploadAttachments,
      getLoadingStatus,
      entityName,
      errorsList,
      adprenewal,
      handleCheckListAnswer,
      standform,
      renewalApplicationData,
      from,
      dateEditable,
      isSignatureUpload = false,
      adp,
      selectedCategory,
      adpAttachments,
      isCrop,
      isRotate,
      errorListMCG,
      applicationType,
      Badging,
      fromForms,
      defaultLocation,
      forQuestionMarkHelp,
      dataSourceValues,
      formEntryFields,
      formApprovalSteps,
      canUseDataSourceFromAvp,
      formEntryDetails,
      collapseOnlyForMiddleName,
      linkedFormAnswerDetails
    } = this.props;
    const { showFormErrors, requiredMap, answers, info, tenantName, errors, Company, standRequest, fieldErrors } = this.props;
    let adminUser = true;
    adminUser = false;
    const { previewUrl, hasDrawnSignature } = this.state;
    const handleUseHelpText = helpText => (
      <>
        {helpText?.description && helpText.description?.length > 0 && (
          <TooltipWithHeading
            title="Help"
            toolTip={`form.setting.newfield.helptext.${helpText.description}`}
            text={helpText.description}
            values={helpText.description}
            iconStyles={styles.helpTooltip}
          />
        )}
      </>
    );
    const helpTextTool = helpText => (
      <>
        {helpText?.rte_description && helpText.rte_description?.length > 0 && (
          <TooltipWithHeading
            title="Help"
            toolTip={`form.setting.newfield.helptext.${helpText.rte_description}`}
            text={helpText.rte_description}
            values={helpText.rte_description}
            iconStyles={styles.tooltip}
          />
        )}
      </>
    );
    const getStyles = (field) => {
      if (field.full_width) {
        return styles.fullWidth;
      } if (adp) {
        return styles.width;
      }
        return '';
    };

     const isSSiFieldfromForms = field => (myforms ? field?.type !== 'ssi_field' && field?.disable_for_portal !== true : true);

    // turn them into arrays
    const imageExts = imageFileExtensions
      .split(',')
      .map(ext => ext.trim().toLowerCase());

    const docExts = docFileExtensions
      .split(',')
      .map(ext => ext.trim().toLowerCase());

    // helper to extract extension (without the dot)
    const getExtension = (url) => {
      const match = url.match(/\.([^.?#]+)$/); // capture group after last dot
      return match ? match[1].toLowerCase() : ''; // use [1] (group), not [0]
    };

    return (
    <div className={fieldPropStyles || (myforms ? `${styles.details_form} ${styles.formOverride} ${standRequest ? '' : styles.myforms_details_form}`
      : styles.details_form)} style={collapseOnlyForMiddleName ? { width: '212px' } : {}}>
      { requiredMap
        && fields?.map(field => (
          <>
            {!field.conditional && !field?.isDisabled &&field.hide_for_all_users !==true&& (
              <>
                {field.type === 'header' && !adp && (
                  <>
                    {!field.collapsible && (!field.enable_rte || field.enable_rte === false) && (
                      <div className={styles.headerapplication}>
                        {field?.title === 'Forms of Identification'
                        ? (
                            <div>
                              Forms of Identification
                              <br />
                              <p className={styles.font}>
                              U.S Citizens born outside the United States must attach a U.S
                              Passport, Certificate of Naturalization or Certification of Birth Abroad.
                              </p>
                            </div>
                          )
                          : (
                              <div>
                                {field.title}
                                {myforms && (
                                  <>
                                    {field?.rte_description && field.rte_description?.length > 0 && (
                                      helpTextTool(field)
                                    )}
                                    {field?.description && field.description?.length > 0 && (
                                      handleUseHelpText(field)
                                    )}
                                  </>
                                )}
                              </div>
                        )}
                      </div>
                    )}
                    {field.collapsible ? (
                      <div className={styles.collapseHeader}>
                        <Collapsible
                          title={field.title} openOnMount
                          styleClasses={styles.header}
                          collapseDesc
                        >
                          {field?.enable_rte ? (
                            <div>
                              <div className={styles.description} dangerouslySetInnerHTML={{ __html: field.rte_description }} />
                            </div>
                            ) : (
                            <div className={styles.description}>
                              <p>{field.description}</p>
                            </div>
                          )}
                          {field.settings?.enableSectionHeaderImg
                            && field.settings?.sectionHeaderImgUrl
                            && field.settings.sectionHeaderImgUrl
                              .split(';')
                              .map((fileUrl) => {
                                const ext = getExtension(fileUrl); // <-- helper to extract extension
                                const key = fileUrl; // use the url as key

                                if (imageExts.includes(ext)) {
                                  return (
                                    <img
                                      key={key}
                                      src={fileUrl}
                                      alt="header-url-ref"
                                      style={{
                                        objectFit: 'contain',
                                        maxWidth: '100%',
                                        height: 'auto',
                                        display: 'block',
                                        marginBottom: '8px'
                                      }}
                                    />
                                  );
                                }

                                if (docExts.includes(ext)) {
                                  return (
                                    <a
                                      key={key}
                                      href={fileUrl}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      style={{
                                        color: '#0d6efd',
                                        textDecoration: 'underline',
                                        display: 'block',
                                        marginBottom: '8px'
                                      }}
                                    >
                                      {fileUrl}
                                    </a>
                                  );
                                }

                                return null; // ignore unsupported files
                              })}
                        </Collapsible>
                      </div>
                    ): (
                      <>
                        <div className={styles.description}>
                          {field?.enable_rte ? (
                            <div>
                              <div className={styles.description} dangerouslySetInnerHTML={{ __html: field.rte_description }} />
                            </div>
                            ) : (
                            <div className={styles.description}>
                              <p>{field.description}</p>
                            </div>
                          )}
                          {field.settings?.enableSectionHeaderImg
                            && field.settings?.sectionHeaderImgUrl
                            && field.settings.sectionHeaderImgUrl
                              .split(';')
                              .map((fileUrl) => {
                                const ext = getExtension(fileUrl); // <-- helper to extract extension
                                const key = fileUrl; // use the url as key

                                if (imageExts.includes(ext)) {
                                  return (
                                    <img
                                      key={key}
                                      src={fileUrl}
                                      alt="header-url-ref"
                                      style={{
                                        objectFit: 'contain',
                                        maxWidth: '100%',
                                        height: 'auto',
                                        display: 'block',
                                        marginBottom: '8px'
                                      }}
                                    />
                                  );
                                }

                                if (docExts.includes(ext)) {
                                  return (
                                    <a
                                      key={key}
                                      href={fileUrl}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      style={{
                                        color: '#0d6efd',
                                        textDecoration: 'underline',
                                        display: 'block',
                                        marginBottom: '8px'
                                      }}
                                    >
                                      {fileUrl}
                                    </a>
                                  );
                                }

                                return null; // ignore unsupported files
                              })}
                        </div>
                      </>
                    )}
                  </>
                )}
                {field.type === 'header' && adp && (
                  <>
                    {field.collapsible ? (
                      <div className={styles.collapseHeader}>
                        <Collapsible
                          title={field.title} openOnMount={!adp}
                          styleClasses={styles.header}
                          collapsibleHeight="0"
                        >
                          {field?.enable_rte && (
                          <div>
                            {/* eslint-disable-next-line react/no-danger */}
                            <div className={styles.description} dangerouslySetInnerHTML={{ __html: field.rte_description }} />
                          </div>
                          )}
                        </Collapsible>
                      </div>
                    ): (
                      <div style={{ width: '100%' }}>
                        <div className={styles.header}>
                          {field?.title}
                        </div>
                        {field?.enable_rte && (
                        <div>
                          {/* eslint-disable-next-line react/no-danger */}
                          <div className={styles.description} dangerouslySetInnerHTML={{ __html: field.rte_description }} />
                        </div>
                        )}
                      </div>
                    )}
                  </>
                )}
                {field.type === 'annotation' && field?.annotate_attachment?.length > 0 && field?.annotate_attachment[0]?.url &&(
                  <div style={{ width: '100%' }}>
                    {field.required && <small style={{ color: 'red' }}> * </small> }
                    <span className={styles.field_title}>{field.title}</span>
                    <Annotations imgSrc={(answers[field.id]?.length > 0 && answers[field.id][0]?.url)
                    ? answers[field.id][0]?.url : field?.annotate_attachment[0]?.url}
                    existingImgSrc={field?.annotate_attachment[0]?.url} existingPaths={answers[field.id] || []}
                    handleFieldErrorChanged={error => handleFieldErrorChanged(field.id, error)}
                    handleSavePath={val => handleAnswerChanged(val, field.id)} drawMode annotateId={field.id} />
                    {showFormErrors && field?.required && (
                        <small style={{ color: 'red' }}>
                            {(!answers[field?.id] || (answers[field?.id]?.length === 0)) && (
                              <FormattedMessage id="pulpoforms.errors.not_blank" defaultMessage="This field cannot be empty" />
                            )}
                        </small>)}
                  </div>)}
                {field.type !== 'header'
                && field.type !== 'page_break'
                  && field.type !== 'attachments'
                  && field.type !== 'map_location'
                  && field.type !== 'signature'
                  && field?.type !== 'multi_field'
                  && field.type !== 'portal_user'
                  && field?.type !== 'multi_level' && field.type !== 'annotation'
                  && field.type !== 'inspection_checklist'
                  && field?.dataSourceID !== 'ds10'
                  && field?.dataSourceID !== 'ds13'
                  && field?.type !== 'duration'
                  && field.type !== 'toggle'
                  && field.type !== 'address' && field?.id !== 'height' && field?.type !== 'risk_assess' && isSSiFieldfromForms(field) &&!(field?.type === 'dataSourceMultiLevel' && field?.dataSourceID === 'ds2' && myforms) &&(
                    <>
                    {!field?.isDisabled && field?.dataSourceID !== 'ds14' && <PulpoField
                      handleUseHelpText={handleUseHelpText(field)}
                      standform={standform}
                      key={field.id}
                      {...field}
                      forQuestionMarkHelp={forQuestionMarkHelp}
                      onlyTime={['time', 'only_time', 'only_time_with_seconds'].includes(field.type)}
                      translation={field.title}
                      avp={!adp}
                      adp={adp}
                      handleValueChange={handleAnswerChanged}
                      isRequired={requiredMap[field.id] || field.required}
                      answer={answers[field?.id]}
                      customField
                      allFields={fields}
                      showFieldErrors={this.getShowFieldErrors(field, renewal, requiredMap, fromForms, fieldErrors, showFormErrors, errorsList, adprenewal, errors)}
                      handleFieldErrorChanged={handleFieldErrorChanged}
                      allDataSources={allDataSources}
                      // className={field.full_width ? styles.fullWidth : field.id==='middle_name' ? styles.middle: field.id === 'aliases_first' ? styles.field : field.id==='aliases_middle' ? styles.middle : field.id === 'aliases_last' ? styles.field : field.id==='zip' ? styles.zip : styles.width}
                      className={field.full_width
                        ? styles.fullWidth
                        : field.id==='d2'
                        ? styles.fullWidth
                        : field.id==='middle_name'
                        ? styles.middle
                        :field.id === 'aliases_first'
                        ? styles.field
                        : field.id==='aliases_middle'
                        ? styles.middle
                        : field.id === 'aliases_last'
                        ? styles.field
                        : field.id==='state'
                        ? styles.state
                        : field.id==='zip'
                        ? styles.zip
                        : field.id === 'country'
                        ? styles.country
                        : field.id === 'ethnicity'
                        ? styles.ethnicity
                        : field.id==='height'
                        ? styles.height
                        : field.id === 'weight'
                        ? styles.height
                        : field.id === 'employer'
                        ? styles.ethnicity
                        : field.id === 'job_title'
                        ? styles.ethnicity
                        : field.id === 'dob' ? styles.fullWidth
                        : (myforms || myformApprovals) && !standRequest ? styles.formsWidth : styles.width}
                      noDefault={
                        (field.type === 'time'
                          || field?.type?.includes('date'))
                        && !field?.default
                      }
                      disabled={(edit && field.lock && adminUser) || field?.disable || (!Badging && field.disable_for_portal) || (field.type === 'string' && field?.hide_default_text) || (selectedCategory && field?.id === 'category_of_adp' && adp)
                                || (applicationType === 'Renewal' && field?.id === 'category_of_adp' && answers[field?.id])}
                      Badging
                      min={field?.type === 'number' ? '0' : ''}
                      locations={globalLocationList}
                      myforms={myforms}
                      dateEditable={dateEditable}
                      placeHolder={placeHolders && placeHolders[field.id]}
                      type={`${this.handleGetFieldType(field)}`}
                      {...this.getOtherFieldInfo(field)}
                      customError={errorsList && errorsList[field.id]}
                      tenantName={tenantName}
                      customFields={fields}
                      formTabFeilds={formTabFeilds}
                      answers={answers}
                      standRequest={standRequest}
                      fieldErrors={fieldErrors}
                      fullWidth={field?.full_width|| false}
                      formEntryFields={formEntryFields}
                      formApprovalSteps={formApprovalSteps}
                      canUseDataSourceFromAvp={canUseDataSourceFromAvp}
                      exposeFieldsList={formEntryDetails?.latest_version?.schema?.fields || []}
                      exposeFieldsData={formEntryDetails?.data || {}}
                    />}
                    </>
                  )}
                  {adp && field?.id === 'height' && !Badging && !field?.isDisabled && (
                    <PulpoField
                      handleUseHelpText={handleUseHelpText(field)}
                      key={field.id}
                      {...field}
                      forQuestionMarkHelp={forQuestionMarkHelp}
                      translation={field.title}
                      avp={!adp}
                      adp={adp}
                      handleValueChange={handleAnswerChanged}
                      isRequired={requiredMap[field.id] || field.required}
                      answer={answers[field?.id]}
                      allFields={fields}
                      showFieldErrors={this.getShowFieldErrors(field, renewal, requiredMap, fromForms, fieldErrors, showFormErrors, errorsList, adprenewal, errors)}
                      handleFieldErrorChanged={handleFieldErrorChanged}
                      className={field.full_width ? styles.fullWidth : styles.width}
                      disabled={field?.disable}
                      type={`${this.handleGetFieldType(field)}`}
                      customError={errorsList && errorsList[field.id]}
                      answers={answers}
                      fieldErrors={fieldErrors}
                      fullWidth={field?.full_width || false}
                    />
                  )}
                  {field.type=== 'select' && field?.settings?.codeValues
                    && (
                  <>
                    <PulpoField
                      key={field.id}
                      id={field.id}
                      type="string"
                      title={field?.settings?.textForCodedValues}
                      disabled
                      handleValueChange={handleAnswerChanged}
                      answer={answers && field?.values[answers[field.id]]?.coded_value}
                      showFieldErrors={showFormErrors}
                      handleFieldErrorChanged={handleFieldErrorChanged}
                      forQuestionMarkHelp={forQuestionMarkHelp}
                    />
                  </>)
                  }
                {field?.type === 'duration' && (
                  <PulpoField
                    key={field.id}
                    {...field}
                    forQuestionMarkHelp={forQuestionMarkHelp}
                    translation={`${field?.title} (${field?.duration_fields?.calculationFormat?.name})`}
                    handleValueChange={handleAnswerChanged}
                    isRequired={requiredMap[field.id]}
                    answer={answers[field.id]}
                    customError={errorsList && errorsList[field.id]}
                    placeHolder={placeHolders && placeHolders[field.id]}
                    formField
                    fromMeeting
                    showFieldErrors={showFormErrors}
                    handleFieldErrorChanged={handleFieldErrorChanged}
                    // eslint-disable-next-line no-nested-ternary
                    className={field.full_width ? styles.fullWidth : ''}
                    type={field.type}
                    {...this.props}
                    answers={answers}
                    fullWidth={field?.full_width || false}
                  />
                )}
                      { field.id === 'dob'
                        && (
                        <div style={{ flex: '1 1 800px' }}>
                        <small style={{ color: 'red' }}>
                        <p className={styles.attachmentsError}>
                          {ageCheck}
                        </p>
                        </small>
                        </div>
                        )}
                  {field.type === 'address' && !field?.isDisabled &&(
                    <PulpoField
                    key={field.id}
                    {...field}
                    forQuestionMarkHelp={forQuestionMarkHelp}
                    onlyTime={['time', 'only_time', 'only_time_with_seconds'].includes(field.type)}
                    translation={field.title}
                    handleValueChange={handleAnswerChanged}
                    isRequired={requiredMap[field.id]}
                    answer={Company ? answers && ((field.type === 'address' && typeof answers[field?.id] === 'object')
                      ? this.getAddress(answers[field.id]) : answers[field.id]) : answers[field.id]}
                    customField
                    myforms={myforms}
                    showFieldErrors={!renewal && showFormErrors}
                    handleFieldErrorChanged={handleFieldErrorChanged}
                    allDataSources={allDataSources}
                    // className={field.full_width ? styles.fullWidth : field.id==='middle_name' ? styles.middle: field.id === 'aliases_first' ? styles.field : field.id==='aliases_middle' ? styles.middle : field.id === 'aliases_last' ? styles.field : field.id==='zip' ? styles.zip : styles.width}
                    className={field.full_width
                      ? styles.fullWidth
                      : field.id==='middle_name'
                      ? styles.middle
                      :field.id === 'aliases_first'
                      ? styles.field
                      : field.id==='aliases_middle'
                      ? styles.middle
                      : field.id === 'aliases_last'
                      ? styles.field
                      : field.id==='state'
                      ? styles.state
                      : field.id==='zip'
                      ? styles.zip
                      : field.id === 'country'
                      ? styles.country
                      : field.id === 'ethnicity'
                      ? styles.ethnicity
                      : field.id==='height'
                      ? styles.height
                      : field.id === 'weight'
                      ? styles.height
                      : field.id === 'employer'
                      ? styles.ethnicity
                      : field.id === 'job_title'
                      ? styles.ethnicity
                      : myforms && !standRequest ? styles.formsWidth : styles.width}
                    noDefault={
                      (field.type === 'time'
                        || field.type?.includes('date'))
                      && !field?.default
                    }
                    Badging={Company ? myforms : !myforms}
                    disabled={(edit && field.lock && adminUser) || (field?.disable) || field.disable_for_portal}
                    systemGenerated={field?.system_generated}
                  />
                  )}

                  {!adp && field?.id === 'height' && !field?.isDisabled &&(
                      <>
                        <div className={styles.heightcontainer}>
                          <div className="ml-1">
                              <FormattedMessageWithClass
                              className={styles.label} id={field?.title}
                              defaultMessage={field?.title}
                              />
                          </div>
                          <div className={styles.feetdiv}>
                              <PulpoField key="feet" id="feet" type="number" title="Feet"
                                  translationID="forms.complete.email1"
                                  forQuestionMarkHelp={forQuestionMarkHelp}
                                  handleValueChange={handleAnswerChanged}
                                  answer={info?.feet} isRequired
                                  className={`${styles.feet} ${field?.full_width && styles.heightCard}`}
                                  showFieldErrors={!renewal && showFormErrors}
                                  handleFieldErrorChanged={handleFieldErrorChanged}
                                  Badging
                                  min="0"
                                  keypress={e => e.charCode >= 48 || e.preventDefault()}
                              />
                              <PulpoField key="inches" id="inches" type="number" title="Inches"
                                  translationID="forms.complete.email1"
                                  handleValueChange={handleAnswerChanged}
                                  forQuestionMarkHelp={forQuestionMarkHelp}
                                  answer={info.inches} isRequired
                                  className={`${styles.feet} ${field?.full_width && styles.heightCard}`}
                                  showFieldErrors={!renewal && showFormErrors}
                                  handleFieldErrorChanged={handleFieldErrorChanged}
                                  Badging
                                  min="0"
                                  keypress={e => e.charCode >= 48 || e.preventDefault()}
                              />
                          </div>
                        </div>
                      </>
                  )}
                  {field.type === 'signature' && !field?.isDisabled && (
                  <>
                    {!field.id?.startsWith('ex-') && (
                      <>
                    <div className={styles.signature}>
                    {previewUrl[field.id] && isSignatureUpload && (
                      <>
                        {field.required && <small style={{ color: 'red' }}> * </small>}
                        <FormattedMessageWithClass
                          className={styles.label} id={field.title}
                          defaultMessage={field.title}
                        />
                      </>
                    )}
                    {!previewUrl[field.id] && (
                      <>
                      {field.required && <small style={{ color: 'red' }}> * </small>}
                        <FormattedMessageWithClass
                          className={styles.label} id={field.title}
                          defaultMessage={field.title}
                        />
                      {answers[field.id] && !renewalApplicationData && answers[field.id][0]?.url && (
                        <img src={answers[field.id][0]?.url} alt="" className={entityName === 'adp' ? `${styles.draftSignature} ${styles.image}` : `${styles.image}`} />
                      )}
                      <div style={answers[field.id] && answers[field.id].length && !renewalApplicationData
                        ? { visibility: 'hidden', height: 0 } : { visibility: 'visible' }}>
                        <SignatureCanvas
                          ref={(ref) => {
                            if (ref) {
                              this.sigCanvas[field.id] = ref;
                            }
                          }}
                          penColor="black"
                          canvasProps={{ width: 900, height: 152, className: styles.sigCanvas }}
                          onEnd={() => {
                            this.handleSign(field.id);

                            this.setState(prev => ({
                              hasDrawnSignature: {
                                ...prev.hasDrawnSignature,
                                [field.id]: true
                              }
                            }));
                          }}
                        />
                      </div>
                      {!isSignatureUpload && (
                        <Button
                          action="tertiary"
                          onClick={() => this.signClear(field.id, field.required)}
                          translationID="filters.form.clear"
                          defaultText="clear"
                          className={`${myforms ? styles.signSty : styles.button}`}
                        />
                      )}

                      {!isSignatureUpload && showFormErrors && field.required && !renewal && (
                        <small style={{ color: 'red' }}>
                          {(!answers[field.id] || (answers[field.id].length === 0)) && (
                            <FormattedMessage id="pulpoforms.errors.not_blank"
                              defaultMessage="This field cannot be empty"
                            />
                          )}
                        </small>
                      )}
                      </>
                    )}
                    {isSignatureUpload && (
                      <div>
                      {previewUrl[field.id] && (
                        <img
                          src={previewUrl[field.id]}
                          alt="Preview"
                          style={{
                            width: 825,
                            height: 152,
                            className: styles.sigCanvas
                          }}
                        />
                      )}
                      {isSignatureUpload && (
                      <span style={{ display: 'flex', flexDirection: 'column' }}>
                      <FormattedMessage
                      id="documents.upload.file.allowed_types"
                      defaultMessage="Note: You can draw your signature or upload an image in .jpg, .jpeg, or .png format."
                      />
                      </span>
                      )}
                      {isSignatureUpload && showFormErrors && field.required && !renewal && (
                        <small style={{ color: 'red' }}>
                          {(!answers[field.id] || (answers[field.id].length === 0)) && (
                            <FormattedMessage id="pulpoforms.errors.not_blank"
                              defaultMessage="This field cannot be empty"
                            />
                          )}
                        </small>
                      )}
                      <div
                          style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            padding: '10px 20px'
                          }}
                        >
                        <input type="file"
                          accept={'.png, .jpg, .jpeg'}
                          style={{ marginLeft: '-19px' }}
                          disabled={hasDrawnSignature[field.id]}
                          onChange={(e) => {
                            if (checkFilesValidation(e.target.files[0], imageFileExtensions)) {
                              this.handleFileChange(e, field.id);
                            }
                          }}
                          id={`driver_signature_upload_file_input_${field.id}`}
                          />
                        <Button
                          action="tertiary"
                          onClick={() => this.signClear(field.id, field.required)}
                          translationID="filters.form.clear"
                          defaultText="clear"
                          className={`${styles.button} ${styles.buttonPadding}`}
                        />
                      </div>
                      </div>
                    )}
                    </div>
                      </>
                    )}
                    {field.id?.startsWith('ex-') && (
                      <PulpoField
                        key={field.id}
                        {...field}
                        handleValueChange={handleAnswerChanged}
                        isRequired={field.required}
                        answer={answers && answers[field.id]}
                        handleSignData={this.handleSignData}
                        showFieldErrors={showFormErrors}
                        handleFieldErrorChanged={handleFieldErrorChanged}
                        allDataSources={allDataSources}
                        disabled={field?.hide_default_text}
                        isRequired2={field.required}
                        exposeSign
                        fullWidth={field?.full_width || false}
                        forQuestionMarkHelp={forQuestionMarkHelp}
                      />
                    )}
                  </>
                )}
                {field.type === 'map_location'
                  && user
                  && user.portal_airport
                  && Object.keys(user.portal_airport.location).length > 0
                  && user.portal_airport.location?.coordinates?.length > 0 && (
                    <>
                      {field?.shape === 'All' || field?.settings?.allow_multiple_location ? (
                        <PulpoField
                          key={field.id}
                          {...field}
                          type="multi_location"
                          shape={field?.shape !== 'All' ? field?.shape : undefined}
                          title={field?.title}
                          isRequired={requiredMap[field.id]}
                          handleValueChange={(a, b, type) => this.handleMultiLocation(
                            a, b, type, field?.id, field?.settings?.allow_multiple_location
                          )}
                          handleValueRemove={(a, b, type) => this.handleRemoveChanged(
                            a, b, type, field?.id, field?.settings?.allow_multiple_location
                          )}
                          handleValueEdit={(a, b, type, key) => this.handleEditChanged(
                            a, b, type, key, field?.id, field?.settings?.allow_multiple_location
                          )}
                          answer={answers && answers[field.id]}
                          disabled={(edit && field.lock && adminUser) || (field.disable_for_portal)}
                          className={styles.fullWidth}
                          handleFieldErrorChanged={handleFieldErrorChanged}
                          showFieldErrors={showFormErrors}
                          fromForms
                          enableDelete
                          allowMultiple={field?.settings?.allow_multiple_location}
                          airportInfo={{
                            location: user?.portal_airport?.location?.coordinates,
                            map_style: user?.portal_airport?.airport_settings?.map_style,
                            mapbox_style: user?.portal_airport?.airport_settings?.mapbox_style,
                            custom_map_url: user?.portal_airport?.airport_settings?.custom_map_url
                          }}
                        />
                      ) : (
                        <PulpoField
                          key={field.id}
                          {...field}
                          forQuestionMarkHelp={forQuestionMarkHelp}
                          title={
                            field?.address_location
                              ? 'Add Address'
                              : field.title
                          }
                          translationID={
                            field?.address_location
                              ? 'custom_field.address.title'
                              : field.title
                          }
                          locationId={field.title}
                          locationTitle={field.title}
                          handleValueChange={handleAnswerChanged}
                          isRequired={requiredMap[field.id]}
                          answer={answers && answers[field.id]}
                          addressEnabled={field?.address_location}
                          showFieldErrors={showFormErrors}
                          handleFieldErrorChanged={handleFieldErrorChanged}
                          myforms={myforms}
                          enableDelete
                          className={styles.fullWidth}
                          disabled={(edit && field.lock && adminUser) || (field.disable_for_portal)}
                          {...this.props}
                          airportInfo={{
                            location: user?.portal_airport?.location?.coordinates,
                            map_style: user?.portal_airport?.airport_settings?.map_style,
                            mapbox_style: user?.portal_airport?.airport_settings?.mapbox_style,
                            custom_map_url: user?.portal_airport?.airport_settings?.custom_map_url
                          }}
                        />
                      )}
                    </>
                  )}
                  {field.type === 'attachments' && (
                    <Attachments
                      {...field}
                      handleAnswerChanged={handleAnswerChanged}
                      attachments={answers[field.id]}
                      showFieldErrors={showFormErrors}
                      handleRemove={handleRemove}
                      adp={adp}
                      adpAttachments={adpAttachments}
                      handleAttachmentFailedAlert={handleAttachmentFailedAlert}
                      handleAutoUploadAttachments={handleAutoUploadAttachments}
                      getLoadingStatus={getLoadingStatus}
                      entityName={entityName}
                      isCrop={isCrop}
                      profilePic={profilePic}
                      isRotate={isRotate}
                      myforms={myforms}
                      handleFieldErrorChanged={handleFieldErrorChanged}
                      disabled={field.disable_for_portal || (profilePic && answers[field.id]?.length > 0 && field.id === 'photo')}
                    />
                  )}
                  {field?.type === 'dataSourceMultiLevel' && field?.dataSourceID === 'ds2' && myforms && (
                    <MultiLevelLocation
                      info={{ ...answers, global_location: answers?.[field?.id], location: answers?.[field?.id]?.map_loaction || defaultLocation }}
                      locationList={globalLocationList || []}
                      onInfoChange={(a, b, c) => handleAnswerChanged(b, a, c)}
                      fieldName={field?.levels}
                      withoutDepartments
                      locationKey="name"
                      withFloorPlan
                      fromSMS
                      field={field}
                      fieldId={field?.id}
                      isRequiredTrue={field?.required}
                      showFormErrors={showFormErrors}
                      handleFieldErrorChanged={(a, b) => handleFieldErrorChanged(field?.id, b)}
                      singleLocation={false}
                      defaultLocation={defaultLocation}
                      location_marked={answers[field?.id]?.location_marked}
                      assetRegistry
                    />
                )}
                  {field?.type === 'multi_field' && (
                      <MultiColumnGrid
                        currentField={field}
                        handleAnswerChanged={handleAnswerChanged}
                        answers={answers}
                        handleUploadAttachments={handleUploadAttachments}
                        flexWrap
                        disabled={field.disable_for_portal}
                        showFormErrors={showFormErrors}
                        errorListMCG={errorListMCG}
                        allFields={fields}
                        from={'from'}
                        handleFieldErrorChanged={handleFieldErrorChanged}
                        allDataSources={allDataSources}
                        dataSourceValues={dataSourceValues}
                        linkedFormAnswerDetails={linkedFormAnswerDetails}
                        user={user}
                      />
                  )}
                  { field?.type === 'multi_level'
                  && <>
                    {/* don't even change the props passing position here,
                          it will raise not displaying or page break issues */}
                    <PulpoField
                      {...field}
                      forQuestionMarkHelp={forQuestionMarkHelp}
                      levels={{
                        level_0: {
                          title: `${field?.title}`
                        },
                        level_1: {
                          title: `${field?.title} 1`
                        },
                        level_2: {
                          title: `${field?.title} 2`
                        }
                      }}
                      title={field?.title}
                      values={typeof field.values === 'object'
                        ?Object.values(field.values).map(item => ({ ...item, name: item.title })):[]}
                      handleValueChange={handleAnswerChanged}
                      handleFieldErrorChanged={handleFieldErrorChanged}
                      isRequired={requiredMap[field.id]}
                      showFieldErrors={showFormErrors}
                      forFormModule
                      answer={answers && answers[field.id]}
                      type="dataSourceMultiLevel"
                      disabled={field.disable_for_portal}
                    />
                     </>
                }
                {field.type === 'inspection_checklist' && (
                    <PulpoField
                      key={field.id}
                      {...field}
                      forQuestionMarkHelp={forQuestionMarkHelp}
                      translation={field.title}
                      handleValueChange={handleCheckListAnswer}
                      isRequired={requiredMap[field.id]}
                      answer={answers && answers[field.id]}
                      showFieldErrors={showFormErrors}
                      handleFieldErrorChanged={handleFieldErrorChanged}
                      className={styles.fullWidth}
                      type={field.type}
                        {...this.props}
                    />
                  )}
                {field.type === 'portal_user' && (
                  <PulpoField
                    key={field.id}
                    {...field}
                    forQuestionMarkHelp={forQuestionMarkHelp}
                    values={this.handleGetPortalUsersValues(field) || []}
                    title={field?.title}
                    handleValueChange={handleAnswerChanged}
                    isRequired={requiredMap[field.id]}
                    answer={answers && answers[field.id]}
                    showFieldErrors={showFormErrors}
                    handleFieldErrorChanged={handleFieldErrorChanged}
                    // eslint-disable-next-line no-nested-ternary
                    className={field.full_width ? styles.fullWidth
                    : (myforms || myformApprovals) && !standRequest ? styles.formsWidth : styles.width}
                    default_value={field?.default_value}
                    type="select"
                    widget={{ type: 'portal_user' }}
                    isHideCompanyName={field?.settings?.show_tenant_specific_users_in_portal_user_field || false} // NO NEED TO SHOW COMPANY NAME WHEN THERE IS ONE TENANT
                  />
                )}
                {field.type === 'dataSource' && field.dataSourceID === 'ds10' && field.dataSourceID === 'ds13' &&(
                  <PulpoField
                    key={field.id}
                    {...field}
                    forQuestionMarkHelp={forQuestionMarkHelp}
                    translation={field.title}
                    handleValueChange={handleAnswerChanged}
                    isRequired={requiredMap[field.id]}
                    answer={answers && answers[field.id]}
                    showFieldErrors={showFormErrors}
                    handleFieldErrorChanged={handleFieldErrorChanged}
                    className={styles.fullWidth}
                    type={'wildlife_species'}
                    disabled={field.disable_for_portal}
                    {...this.props}
                  />
                )}
                  {field?.type === 'toggle'
                    && <PulpoField
                    key={field.id}
                    {...field}
                    forQuestionMarkHelp={forQuestionMarkHelp}
                    translation={field.title}
                    handleValueChange={handleAnswerChanged}
                    isRequired={requiredMap[field.id]}
                    answer={field}
                    toggleAnswers={answers}
                    showFieldErrors={showFormErrors}
                    handleFieldErrorChanged={handleFieldErrorChanged}
                    className={styles.fullWidth}
                    type={field?.type}
                    needFlex
                    fromToggle
                      {...this.props}
                  />
                  }

              </>
            )}
            {field.conditional && field.hide_for_all_users !==true
              && this.checkValueInFormEntry(field)
              && this.checkConditionalValue(field) && (
                <>
                  {field.type === 'header' && !field?.isDisabled && !adp && (
                    <>
                      {field.collapsible ? (
                        <div className={styles.collapseHeader}>
                          <Collapsible
                            title={field.title} openOnMount
                            styleClasses={styles.header}
                          >
                            <div className={styles.description}>
                              <p>{field.description}</p>
                            </div>
                          </Collapsible>
                        </div>
                      ): (
                        <>
                          <div className={styles.header}>
                            {field.title}
                          </div>
                          <div className={styles.description}>
                            <p>{field.description}</p>
                          </div>
                        </>
                      )}
                    </>
                  )}
                  {field.type === 'header' && field.enable_rte === true && adp && (
                  <>
                    {field.collapsible ? (
                      <div className={styles.collapseHeader}>
                        <Collapsible
                          title={field.title} openOnMount={!adp}
                          styleClasses={styles.header}
                          collapsibleHeight="0"
                        >
                          <div>
                            {/* eslint-disable-next-line react/no-danger */}
                            <div className={styles.description} dangerouslySetInnerHTML={{ __html: field.rte_description }} />
                          </div>
                        </Collapsible>
                      </div>
                    ): (
                      <div style={{ width: '100%' }}>
                        <div className={styles.header}>
                          {field?.title}
                        </div>
                        <div>
                          {/* eslint-disable-next-line react/no-danger */}
                          <div className={styles.description} dangerouslySetInnerHTML={{ __html: field.rte_description }} />
                        </div>
                      </div>
                    )}
                  </>
                )}
                  {field.type=== 'select' && field?.settings?.codeValues
                    && (
                  <>
                    <PulpoField
                      key={field.id}
                      id={field.id}
                      type="string"
                      title={field?.settings?.textForCodedValues}
                      disabled
                      handleValueChange={handleAnswerChanged}
                      answer={answers && field?.values[answers[field.id]]?.coded_value}
                      showFieldErrors={showFormErrors}
                      handleFieldErrorChanged={handleFieldErrorChanged}
                      forQuestionMarkHelp={forQuestionMarkHelp}
                    />
                  </>)
                  }
                {field.type === 'annotation' && field?.annotate_attachment?.length > 0 && field?.annotate_attachment[0]?.url &&(
                  <div style={{ width: '100%' }}>
                    {field.required && <small style={{ color: 'red' }}> * </small> }
                    <span className={styles.field_title}>{field.title}</span>
                    <Annotations imgSrc={(answers[field.id]?.length > 0 && answers[field.id][0]?.url)
                    ? answers[field.id][0]?.url : field?.annotate_attachment[0]?.url}
                    existingImgSrc={field?.annotate_attachment[0]?.url} existingPaths={answers[field.id] || []}
                    handleFieldErrorChanged={error => handleFieldErrorChanged(field.id, error)}
                    handleSavePath={val => handleAnswerChanged(val, field.id)} drawMode annotateId={field.id} />
                    {showFormErrors && field?.required && (
                        <small style={{ color: 'red' }}>
                            {(!answers[field?.id] || (answers[field?.id]?.length === 0)) && (
                              <FormattedMessage id="pulpoforms.errors.not_blank" defaultMessage="This field cannot be empty" />
                            )}
                        </small>)}
                  </div>)}
                  {field.type !== 'header'
                  && field.type !== 'annotation'
                  && field.type !== 'page_break'
                  && field.type !== 'attachments'
                  && field.type !== 'map_location'
                  && field?.type !== 'multi_field'
                  && field.type !== 'inspection_checklist'
                  && field?.dataSourceID !== 'ds10'
                  && field?.dataSourceID !== 'ds13'
                  && field.type !== 'portal_user'
                  && field?.type !== 'multi_level'
                  && field?.type !== 'duration'
                  && field.type !== 'toggle'
                  && field.type !== 'signature' && field?.type !== 'risk_assess' && !field?.isDisabled && !(field?.type === 'dataSourceMultiLevel' && field?.dataSourceID === 'ds2' && myforms)
                  && field?.dataSourceID !== 'ds14' && (
                      <PulpoField
                        key={field.id}
                        {...field}
                        forQuestionMarkHelp={forQuestionMarkHelp}
                        onlyTime={['time', 'only_time', 'only_time_with_seconds'].includes(field.type)}
                        translation={field.title}
                        handleValueChange={handleAnswerChanged}
                        isRequired={requiredMap[field.id]}
                        answer={answers[field.id]}
                        allFields={fields}
                        customField
                        avp={!adp}
                        adp={adp}
                        showFieldErrors={!renewal && showFormErrors}
                        handleFieldErrorChanged={handleFieldErrorChanged}
                        allDataSources={allDataSources}
                        formTabFeilds={formTabFeilds}
                        className={getStyles(field)}
                        noDefault={
                          (field.type === 'time'
                            || field.type?.includes('date'))
                          && !field?.default
                        }
                        disabled={(edit && field.lock && adminUser) || (!Badging && field.disable_for_portal) || (field.type === 'string' && field?.hide_default_text) || (selectedCategory && field?.id === 'category_of_adp' && adp)
                                 || (applicationType === 'Renewal' && field?.id === 'category_of_adp' && answers[field?.id])}
                        Badging
                        min={field?.type === 'number' ? '0' : ''}
                        locations={globalLocationList}
                        customFields={fields}
                        answers={answers}
                        type={this.handleGetFieldType(field)}
                        canUseDataSourceFromAvp={canUseDataSourceFromAvp}
                        {...this.getOtherFieldInfo(field)}
                      />
                    )}
                  {field?.type === 'duration' && (
                    <PulpoField
                      key={field.id}
                      {...field}
                      forQuestionMarkHelp={forQuestionMarkHelp}
                      translation={`${field?.title} (${field?.duration_fields?.calculationFormat?.name})`}
                      handleValueChange={handleAnswerChanged}
                      isRequired={requiredMap[field.id]}
                      answer={answers[field.id]}
                      customError={errorsList && errorsList[field.id]}
                      placeHolder={placeHolders && placeHolders[field.id]}
                      showFieldErrors={showFormErrors}
                      handleFieldErrorChanged={handleFieldErrorChanged}
                      className={field.full_width ? styles.fullWidth : ''}
                      type={field.type}
                      {...this.props}
                      answers={answers}
                      fullWidth={field?.full_width || false}
                    />
                  )}
                  {field?.type === 'toggle'
                    && <PulpoField
                    key={field.id}
                    {...field}
                    forQuestionMarkHelp={forQuestionMarkHelp}
                    translation={field.title}
                    handleValueChange={handleAnswerChanged}
                    isRequired={requiredMap[field.id]}
                    answer={field}
                    showFieldErrors={showFormErrors}
                    handleFieldErrorChanged={handleFieldErrorChanged}
                    className={styles.fullWidth}
                    type={field?.type}
                    needFlex
                    fromToggle
                    {...this.props}
                  />
                  }
                    {field.type === 'signature' && !field?.isDisabled &&(
                    <>
                      <div className={styles.signature}>
                      {previewUrl[field.id] && isSignatureUpload && (
                        <>
                          {field.required && <small style={{ color: 'red' }}> * </small>}
                          <FormattedMessageWithClass
                            className={styles.label} id={field.title}
                            defaultMessage={field.title}
                          />
                        </>
                      )}
                      {!previewUrl[field.id] && (
                        <>
                        {field.required && <small style={{ color: 'red' }}> * </small>}
                          <FormattedMessageWithClass
                            className={styles.label} id={field.title}
                            defaultMessage={field.title}
                          />
                        {answers[field.id] && !renewalApplicationData && answers[field.id][0]?.url && (
                          <img src={answers[field.id][0]?.url} alt="" className={styles.image} />
                        )}
                        <div style={answers[field.id] && answers[field.id].length && !renewalApplicationData
                          ? { visibility: 'hidden', height: 0 } : { visibility: 'visible' }}>
                          <SignatureCanvas
                            ref={(ref) => {
                              if (ref) {
                                this.sigCanvas[field.id] = ref;
                              }
                            }}
                            penColor="black"
                            canvasProps={{ width: 900, height: 152, className: styles.sigCanvas }}
                            onEnd={() => {
                              this.handleSign(field.id);

                              this.setState(prev => ({
                                hasDrawnSignature: {
                                  ...prev.hasDrawnSignature,
                                  [field.id]: true
                                }
                              }));
                            }}
                          />
                        </div>
                        {!isSignatureUpload && (
                          <Button
                            action="tertiary"
                            onClick={() => this.signClear(field.id, field.required)}
                            translationID="filters.form.clear"
                            defaultText="clear"
                            className={`${myforms ? styles.signSty : styles.button}`}
                          />
                        )}

                        {!isSignatureUpload && showFormErrors && field.required && !renewal && (
                          <small style={{ color: 'red' }}>
                            {(!answers[field.id] || (answers[field.id].length === 0)) && (
                              <FormattedMessage id="pulpoforms.errors.not_blank"
                                defaultMessage="This field cannot be empty"
                              />
                            )}
                          </small>
                        )}
                        </>
                      )}
                      {isSignatureUpload && (
                        <div>
                        {previewUrl[field.id] && (
                          <img
                            src={previewUrl[field.id]}
                            alt="Preview"
                            style={{
                              width: 825,
                              height: 152,
                              className: styles.sigCanvas
                            }}
                          />
                        )}
                        {isSignatureUpload && (
                        <span style={{ display: 'flex', flexDirection: 'column' }}>
                        <FormattedMessage
                        id="documents.upload.file.allowed_types"
                        defaultMessage="Note: You can draw your signature or upload an image in .jpg, .jpeg, or .png format."
                        />
                        </span>
                        )}
                        {isSignatureUpload && showFormErrors && field.required && !renewal && (
                          <small style={{ color: 'red' }}>
                            {(!answers[field.id] || (answers[field.id].length === 0)) && (
                              <FormattedMessage id="pulpoforms.errors.not_blank"
                                defaultMessage="This field cannot be empty"
                              />
                            )}
                          </small>
                        )}
                        <div
                            style={{
                              display: 'flex',
                              justifyContent: 'space-between',
                              padding: '10px 20px'
                            }}
                          >
                          <input type="file"
                            accept={'.png, .jpg, .jpeg'}
                            style={{ marginLeft: '-19px' }}
                            disabled={hasDrawnSignature[field.id]}
                            onChange={(e) => {
                              if (checkFilesValidation(e.target.files[0], imageFileExtensions)) {
                                this.handleFileChange(e, field.id);
                              }
                            }}
                            id={`driver_signature_upload_file_input_${field.id}`}
                            />
                          <Button
                            action="tertiary"
                            onClick={() => this.signClear(field.id, field.required)}
                            translationID="filters.form.clear"
                            defaultText="clear"
                            className={`${styles.button} ${styles.buttonPadding}`}
                          />
                        </div>
                        </div>
                      )}
                      </div>
                    </>
                    )}
                    {field.type === 'inspection_checklist' && (
                      <PulpoField
                        key={field.id}
                        {...field}
                        forQuestionMarkHelp={forQuestionMarkHelp}
                        translation={field.title}
                        handleValueChange={handleCheckListAnswer}
                        isRequired={requiredMap[field.id]}
                        answer={answers && answers[field.id]}
                        showFieldErrors={showFormErrors}
                        handleFieldErrorChanged={handleFieldErrorChanged}
                        className={styles.fullWidth}
                        type={field.type}
                          {...this.props}
                      />
                    )}
                    {field.type === 'attachments' && (
                      <Attachments
                        {...field}
                        isCrop={isCrop}
                        isRotate={isRotate}
                        entityName={entityName}
                        adpAttachments={adpAttachments}
                        getLoadingStatus={getLoadingStatus}
                        handleAutoUploadAttachments={handleAutoUploadAttachments}
                        handleAttachmentFailedAlert={handleAttachmentFailedAlert}
                        handleAnswerChanged={handleAnswerChanged}
                        attachments={answers[field.id]}
                        showFieldErrors={showFormErrors}
                        myforms={myforms}
                        handleFieldErrorChanged={handleFieldErrorChanged}
                        disabled={field.disable_for_portal && (profilePic && answers[field.id]?.length > 0 && field.id === 'photo')}
                      />
                    )}
                    {field.type === 'map_location'
                      && user
                      && user?.portal_airport
                      && Object.keys(user.portal_airport.location).length > 0
                      && user.portal_airport.location?.coordinates?.length > 0 && (
                        field?.shape === 'All' || field?.settings?.allow_multiple_location ? (
                          <PulpoField
                            key={field.id}
                            {...field}
                            type="multi_location"
                            shape={field?.shape !== 'All' ? field?.shape : undefined}
                            title={field?.title}
                            isRequired={requiredMap[field.id]}
                            handleValueChange={(a, b, type) => this.handleMultiLocation(
                              a, b, type, field?.id, field?.settings?.allow_multiple_location
                            )}
                            handleValueRemove={(a, b, type) => this.handleRemoveChanged(
                              a, b, type, field?.id, field?.settings?.allow_multiple_location
                            )}
                            handleValueEdit={(a, b, type, key) => this.handleEditChanged(
                              a, b, type, key, field?.id, field?.settings?.allow_multiple_location
                            )}
                            answer={answers && answers[field.id]}
                            disabled={(edit && field.lock && adminUser) || (field.disable_for_portal)}
                            className={styles.fullWidth}
                            handleFieldErrorChanged={handleFieldErrorChanged}
                            showFieldErrors={showFormErrors}
                            fromForms
                            enableDelete
                            allowMultiple={field?.settings?.allow_multiple_location}
                            airportInfo={{
                              location: user?.portal_airport?.location?.coordinates,
                              map_style: user?.portal_airport?.airport_settings?.map_style,
                              mapbox_style: user?.portal_airport?.airport_settings?.mapbox_style,
                              custom_map_url: user?.portal_airport?.airport_settings?.custom_map_url
                            }}
                          />
                        ) : (
                          <PulpoField
                            key={field.id}
                            {...field}
                            forQuestionMarkHelp={forQuestionMarkHelp}
                            title={
                              field?.address_location
                                ? 'Add Address'
                                : field.title
                            }
                            translationID={
                              field?.address_location
                                ? 'custom_field.address.title'
                                : field.title
                            }
                            locationId={field.title}
                            locationTitle={field.title}
                            handleValueChange={handleAnswerChanged}
                            isRequired={requiredMap[field.id]}
                            answer={answers && answers[field.id]}
                            addressEnabled={field?.address_location}
                            showFieldErrors={showFormErrors}
                            handleFieldErrorChanged={handleFieldErrorChanged}
                            myforms={myforms}
                            enableDelete
                            className={styles.fullWidth}
                            disabled={(edit && field.lock && adminUser) || (field.disable_for_portal)}
                            {...this.props}
                            airportInfo={{
                              location: user?.portal_airport?.location?.coordinates,
                              map_style: user?.portal_airport?.airport_settings?.map_style,
                              mapbox_style: user?.portal_airport?.airport_settings?.mapbox_style,
                              custom_map_url: user?.portal_airport?.airport_settings?.custom_map_url
                            }}
                          />
                        )
                      )}
                    {field?.type === 'multi_field' && (
                        <MultiColumnGrid
                          currentField={field}
                          handleAnswerChanged={handleAnswerChanged}
                          answers={answers}
                          handleUploadAttachments={handleUploadAttachments}
                          flexWrap
                          disabled={field.disable_for_portal}
                          showFormErrors={showFormErrors}
                          errorListMCG={errorListMCG}
                          allFields={fields}
                          from={from}
                          user={user}
                          handleFieldErrorChanged={handleFieldErrorChanged}
                          allDataSources={allDataSources}
                          dataSourceValues={dataSourceValues}
                          linkedFormAnswerDetails={linkedFormAnswerDetails}
                        />
                    )}
                    { field?.type === 'multi_level'
                    && <>
                      {/* don't even change the props passing position here,
                          it will raise not displaying or page break issues */}
                      <PulpoField
                        {...field}
                        forQuestionMarkHelp={forQuestionMarkHelp}
                        levels={{
                          level_0: {
                            title: `${field?.title}`
                          },
                          level_1: {
                            title: `${field?.title} 1`
                          },
                          level_2: {
                            title: `${field?.title} 2`
                          }
                        }}
                        title={field?.title}
                        values={typeof field.values === 'object'
                          ?Object.values(field.values).map(item => ({ ...item, name: item.title })):[]}
                        handleValueChange={handleAnswerChanged}
                        handleFieldErrorChanged={handleFieldErrorChanged}
                        isRequired={requiredMap[field.id]}
                        showFieldErrors={showFormErrors}
                        forFormModule
                        answer={answers && answers[field.id]}
                        type="dataSourceMultiLevel"
                        disabled={field.disable_for_portal}
                      />
                       </>
                    }
                    {field.type === 'portal_user' && (
                      <PulpoField
                        key={field.id}
                        {...field}
                        forQuestionMarkHelp={forQuestionMarkHelp}
                        values={this.handleGetPortalUsersValues(field) || []}
                        title={field?.title}
                        handleValueChange={handleAnswerChanged}
                        isRequired={requiredMap[field.id]}
                        answer={answers && answers[field.id]}
                        showFieldErrors={showFormErrors}
                        handleFieldErrorChanged={handleFieldErrorChanged}
                        // eslint-disable-next-line no-nested-ternary
                        className={field.full_width ? styles.fullWidth
                        : (myforms || myformApprovals) && !standRequest ? styles.formsWidth : styles.width}
                        default_value={field?.default_value}
                        type="select"
                        widget={{ type: 'portal_user' }}
                        isHideCompanyName={field?.settings?.show_tenant_specific_users_in_portal_user_field || false} // NO NEED TO SHOW COMPANY NAME WHEN THERE IS ONE TENANT
                      />
                    )}
                    {field.type === 'dataSource' && field.dataSourceID === 'ds10' && field.dataSourceID === 'ds13' && (
                      <PulpoField
                        key={field.id}
                        {...field}
                        forQuestionMarkHelp={forQuestionMarkHelp}
                        translation={field.title}
                        handleValueChange={handleAnswerChanged}
                        isRequired={requiredMap[field.id]}
                        answer={answers && answers[field.id]}
                        showFieldErrors={showFormErrors}
                        handleFieldErrorChanged={handleFieldErrorChanged}
                        className={styles.fullWidth}
                        type={'wildlife_species'}
                        {...this.props}
                      />
                    )}
                </>
              )}
          </>
        ))}
    </div>
    );
  }
}

CustomFields.propTypes = {
  actionFetchDataSources: PropTypes.func.isRequired,
  forQuestionMarkHelp: PropTypes.bool
};

CustomFields.defaultProps = {
  forQuestionMarkHelp: false
};


const mapStateToProps = state => ({
  allDataSources: state.inspection.allDataSources,
  user: state.auth.profile,
  portal_users_list: state.forms.portal_users_list,
  airportInfo: state.airfields.airportInfo,
  linkedFormAnswerDetails: state.forms.linkedFormAnswerDetails || EMPTY_ARRAY
});

const mapDispatchToProps = dispatch => ({
  actionFetchDataSources: () => {
    dispatch(fetchDataSourceList());
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(CustomFields);
